import { useContext, useMemo } from 'react';
import Box from '@mui/material/Box';
import { mapInterimsTimelineToRadioAcessGraphData } from './utils/interimUtils';
import { ZOOM_VALUES_IN_MINUTES } from './utils/range';
import { ChangingInTimeGraph } from '../common/Graphs/ChangingInTimeGraph';
import { InterimsTimelineContext } from './InterimsTimelineContext';
import { FloatingGraphBox } from '../common/Graphs/components/FloatingGraphBox';
import CircularProgress from '@mui/material/CircularProgress';
import { useInterimsTimeRange } from './hooks/useInterimsTimeRange';
import { pxToRem } from 'src/common/utils/fonts';

export const RadioAccessGraph = () => {
  const {
    fetchingInterims,
    selectStartInterim,
    unselectInterim,
    markSelectedInterimAsDefault,
    startInterimMarked,
    startInterim,
    interimsTimeline,
  } = useContext(InterimsTimelineContext);

  const { selectedRange, availableRange, moveVisibleRangeTo } = useInterimsTimeRange();

  const radioAccessDataset = useMemo(() => {
    return mapInterimsTimelineToRadioAcessGraphData(interimsTimeline);
  }, [interimsTimeline]);

  const isStartMarkerSameValue =
    !!startInterim && startInterim?.radioAccess === radioAccessDataset?.at(-1)?.label;

  return (
    <Box sx={{ position: 'relative', height: pxToRem(83) }}>
      <ChangingInTimeGraph
        highlightStartMarker={startInterimMarked}
        onStartMarkerHovered={(value) => {
          if (value) {
            selectStartInterim();
          } else {
            unselectInterim();
          }
        }}
        onClick={() => {
          markSelectedInterimAsDefault();
        }}
        startMarkerValue={startInterim?.radioAccess}
        isStartMarkerSameValue={isStartMarkerSameValue}
        startMarkerDate={startInterim?.timestamp}
        dataset={radioAccessDataset}
        zoomBoundaryStart={availableRange.from}
        zoomBoundaryStop={availableRange.to}
        maxZoomInMS={ZOOM_VALUES_IN_MINUTES.DAY * 60 * 1000}
        selectedRangeStart={selectedRange.from}
        selectedRangeStop={selectedRange.to}
        onZoomComplete={([min, max]) => {
          moveVisibleRangeTo(min, max);
        }}
        onPan={moveVisibleRangeTo}
      />
      {fetchingInterims ? (
        <FloatingGraphBox>
          <CircularProgress />
        </FloatingGraphBox>
      ) : null}
    </Box>
  );
};
